class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends DetailsDisclosure {
      constructor() {
        super();

        this.elements = {
          shareButton: this.querySelector('button'),
          shareSummary: this.querySelector('summary'),
          closeButton: this.querySelector('.share-button__close'),
          successMessage: this.querySelector('[id^="ShareMessage"]'),
          urlInput: this.querySelector('input'),
          copyButton: this.querySelector('.share-button__copy'),
        };

        // Do NOT lock the URL at load time. Variants change.
        this.urlToShare = null;

        // Keep the fallback input synced to the live URL whenever the details opens
        if (this.mainDetailsToggle) {
          this.mainDetailsToggle.addEventListener('toggle', () => {
            if (this.mainDetailsToggle.open) this.updateUrlToCurrent();
          });
        }

        if (navigator.share) {
          this.mainDetailsToggle.setAttribute('hidden', '');
          this.elements.shareButton.classList.remove('hidden');

          this.elements.shareButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopImmediatePropagation();

            const url = this.getCurrentUrl();
            navigator.share({ url, title: document.title });
          });
        } else {
          this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));

          if (this.elements.copyButton) {
            this.elements.copyButton.addEventListener('click', (e) => {
              e.preventDefault();
              this.updateUrlToCurrent();
              this.copyToClipboard();
            });
          }

          if (this.elements.closeButton) {
            this.elements.closeButton.addEventListener('click', this.close.bind(this));
          }
        }
      }

      getCurrentUrl() {
        // Always share the live URL (should include ?variant=...)
        return window.location.href;
      }

      updateUrlToCurrent() {
        const url = this.getCurrentUrl();
        this.urlToShare = url;
        if (this.elements.urlInput) this.elements.urlInput.value = url;
      }

      toggleDetails() {
        if (!this.mainDetailsToggle.open) {
          this.elements.successMessage.classList.add('hidden');
          this.elements.successMessage.textContent = '';
          this.elements.closeButton.classList.add('hidden');
          this.elements.shareSummary.focus();
        } else {
          // When opening the share panel, ensure the URL is current
          this.updateUrlToCurrent();
        }
      }

      copyToClipboard() {
        const url = this.elements.urlInput ? this.elements.urlInput.value : this.getCurrentUrl();

        navigator.clipboard.writeText(url).then(() => {
          this.elements.successMessage.classList.remove('hidden');
          this.elements.successMessage.textContent = window.accessibilityStrings.shareSuccess;
          this.elements.closeButton.classList.remove('hidden');
          this.elements.closeButton.focus();
        });
      }

      updateUrl(url) {
        // Keep for compatibility if theme calls this
        this.urlToShare = url;
        if (this.elements.urlInput) this.elements.urlInput.value = url;
      }
    }
  );
}